export { default } from './feature-carousel'; // eslint-disable-line
export { default as featureCarouselConfig } from './feature-carousel.config';
